import { configureStore } from "@reduxjs/toolkit";
import contextReducer from "../features/context/contextSlice";
import threeReducer, { threeMiddleware } from "../features/three/threeSlice";
import panelReducer, { panelMiddleware } from "../features/panel/panelSlice";
import translationReducer from "../features/translation/translationSlice";
import appReducer from "../features/app/appSlice";

export const store = configureStore({
  reducer: {
    app: appReducer,
    context: contextReducer,
    three: threeReducer,
    panel: panelReducer,
    translation: translationReducer,
  },
  middleware: [panelMiddleware, threeMiddleware],
});

export default store;
